import getLang from 'I18n/utils/getLang';
import { getProductLineFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
const imageHosts = {
  en: 'https://www.hubspot.com',
  es: 'https://www.hubspot.es',
  de: 'https://www.hubspot.de',
  pt: 'https://br.hubspot.com',
  fr: 'https://www.hubspot.fr',
  ja: 'https://www.hubspot.jp'
};
export const hubToImage = apiName => {
  const lang = getLang();
  let imageLang = 'EN'; // default to english
  let imageHost = imageHosts['en'];
  if (Object.keys(imageHosts).includes(lang)) {
    imageLang = lang.toUpperCase();
    imageHost = imageHosts[lang];
  }
  const productLine = getProductLineFromApiNameString(apiName).toLowerCase();
  const prefix = `${imageHost}/hs-fs/hubfs/TrialsPPP/${productLine}/`;
  return `${prefix}${productLine}_hero_${imageLang}_image.png`;
};